export default "__VITE_ASSET__D$ajdxM6__"